export const KNOX_PHONE_NUMBER = "+1 (647) 560 9475"
export const KNOX_CONTACT_EMAIL = "info@kn0x.io"
